import React, { useContext } from "react";
import { UsuarioContext } from "config/context/UsuarioProvider";

import Periodo from "./sectionsCompra02/Periodo";
import DatosPersonales from "./sectionsCompra02/DatosPersonales";
import SeleccionDatosFacturacion from "./sectionsCompra02/SeleccionDatosFacturacion";

// *** core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

// *** @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// *** Imagenes
import imgDatosPersonalesFea from "assets/img/com-fea/img-datos-personales.png";
import imgDatosPersonales from "assets/img/com-fes/img-datos-personales.png";
import featuresStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/featuresStyle.js";

const useStyles2 = makeStyles(featuresStyle);

export default function SeleccionPeriodo() {
  const { planUser } = useContext(UsuarioContext);
  const classes2 = useStyles2();
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <div className={classes2.features3}>
            {planUser === "CFES" ? (
              <img src={imgDatosPersonales} alt="..." />
            ) : (
              <img src={imgDatosPersonalesFea} alt="..." />
            )}
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Periodo />
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <DatosPersonales />
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <SeleccionDatosFacturacion />
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </div>
  );
}
